// src/context/LanguageContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from '../locales/en.json';
import uz from '../locales/uz.json';
import rus from '../locales/rus.json';

// Initialize translation resources
const resources = {
  en: { translation: en },
  uz: { translation: uz },
  rus: { translation: rus },
};

// Initialize i18next with resources and default language
i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('appLanguage') || 'en', // Load saved language or default to 'en'
  interpolation: {
    escapeValue: false, // React already escapes values to prevent XSS
  },
});

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('appLanguage') || 'en');

  // Switch language and store it in localStorage
  const switchLanguage = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem('appLanguage', lang); // Save to localStorage
  };

  // Load the stored language from localStorage when the component mounts
  useEffect(() => {
    const storedLanguage = localStorage.getItem('appLanguage');
    if (storedLanguage && storedLanguage !== language) {
      setLanguage(storedLanguage);
      i18n.changeLanguage(storedLanguage);
    }
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
